import React from "react"

const TreatmentContext = React.createContext(null as any)

export default TreatmentContext